export default "/images/ed5547e170152df3c813acba5a02a5c2.png";